import { Stack } from "@mui/material";
import { ActivitySection } from "./activity-section";
import { DashboardHeader } from "./components/DashboardHeader";

export const HomeDashboard = () => {
  return (
    <Stack
      sx={{
        height: "100%",
        minHeight: 0,
        overflowY: "auto",
        gap: "8px",
        // pr: "4px",
      }}
    >
      <DashboardHeader />
      <ActivitySection />
    </Stack>
  );
};
